import { Card } from '@mui/material'
import dayjs from 'dayjs'
import queryString from 'query-string'
import { useCallback, useEffect, useState } from 'react'

import useAxios from '../../../../hooks/useAxios'
import DailyReturnReportFilter, {
  IReturnFilterMapped,
} from './components/DailyReturnReportFilter'
import DailyReturnReportTable, {
  IReturnReport,
} from './components/DailyReturnReportTable'

const buildInitialFilter = (): IReturnFilterMapped => {
  const queryStr = queryString.parse(window.location.search)
  return {
    categoryObjectIds: queryStr.categoryObjectIds?.length
      ? String(queryStr.categoryObjectIds).split(',')
      : undefined,
    productObjectIds: queryStr.productObjectIds?.length
      ? String(queryStr.productObjectIds).split(',')
      : undefined,
    productGroups: queryStr.productGroups?.length
      ? String(queryStr.productGroups).split(',')
      : undefined,
    distributionObjectIds: queryStr.distributionObjectIds?.length
      ? String(queryStr.distributionObjectIds).split(',')
      : undefined,
    trackingProvider: queryStr.trackingProvider
      ? String(queryStr.trackingProvider)
      : 'all',
    dateType: queryStr.dateType ? String(queryStr.dateType) : 'returnAt',
    startDate: queryStr.startDate
      ? dayjs(String(queryStr.startDate)).startOf('day').format()
      : dayjs().subtract(30, 'days').format(),
    endDate: queryStr.endDate
      ? dayjs(String(queryStr.endDate)).startOf('day').format()
      : dayjs().format(),
  }
}

const DailyReturnReport = () => {
  const [filter, setFilter] = useState<IReturnFilterMapped>(buildInitialFilter)
  const [searchFilter, setSearchFilter] =
    useState<IReturnFilterMapped>(buildInitialFilter)

  const onFilterChange = useCallback((newFilter: IReturnFilterMapped) => {
    setFilter(newFilter)
  }, [])

  const handleSearch = useCallback((newFilter: IReturnFilterMapped) => {
    setFilter(newFilter)
    setSearchFilter(newFilter)
  }, [])

  useEffect(() => {
    handleSearch(filter)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const returnReport = useAxios<IReturnReport>({
    method: 'GET',
    url: '/report/order-return-reports',
    params: {
      startDate: searchFilter.startDate,
      endDate: searchFilter.endDate,
      dateType: searchFilter.dateType,
      products: searchFilter.productObjectIds,
      productGroups: searchFilter.productGroups,
      categories: searchFilter.categoryObjectIds,
      distribution: searchFilter.distributionObjectIds,
      trackingProvider:
        searchFilter.trackingProvider !== 'all'
          ? searchFilter.trackingProvider
          : undefined,
    },
  })

  return (
    <Card
      sx={{
        padding: 2,
      }}
    >
      <DailyReturnReportFilter
        filter={filter}
        onFilterChange={onFilterChange}
        onSearch={handleSearch}
      />
      <DailyReturnReportTable
        data={returnReport.data}
        isLoading={returnReport.isLoading}
      />
    </Card>
  )
}

export default DailyReturnReport
